module.exports = __webpack_public_path__ + "img/animation_full.f4f9aa00.svg";